import angular from "angular";
import {
  vsDirectiveName as autoNumericDirectiveName,
  autoNumericInputDirective,
} from "./directive";

export const vsModuleName = "SlotTrak.UI.autoNumeric";

angular
  .module(vsModuleName, [])
  .directive(autoNumericDirectiveName, autoNumericInputDirective);
